import React, {
  useEffect,
  useState,
  useCallback,
  useMemo,
  useRef,
} from "react";
import Autosuggest from "react-autosuggest";
import { getAllCustomer } from "../../../server/Customer";
import PopUp from "../../containers/PopUp";
import ListPagination from "../../containers/ListPagination";
import { useSelector, useDispatch } from "react-redux";
import { ArrowLeft, Info, Search as SearchIcon } from "lucide-react";
import { clearSearch } from "../../../server/Product";

const trimAddressField = (value) =>
  value == null || value === "" ? "" : String(value).trim();

const formatUserAddress = (user) => {
  const street = trimAddressField(user?.addrStreet);
  if (!street) return null;
  const city = trimAddressField(user?.addrCity);
  const parts = [
    city,
    `רחוב ${street} ${trimAddressField(user?.addrHouse)}`.trim(),
  ].filter(Boolean);
  const floor = trimAddressField(user?.addrFloor);
  const apartment = trimAddressField(user?.addrApartment);
  const zip = trimAddressField(user?.addrZipCode);
  if (floor) parts.push(`קומה ${floor}`);
  if (apartment) parts.push(`דירה ${apartment}`);
  if (zip) parts.push(`מיקוד ${zip}`);
  return parts.join(", ");
};

const getSuggestionValue = (suggestion) =>
  `${suggestion.firstName || ""} ${suggestion.lastName || ""}`.trim();
const renderSuggestion = (suggestion) => (
  <div className="hello">
    <span>
      {suggestion.firstName || ""} {suggestion.lastName || ""} /{" "}
    </span>
    <span>{suggestion.email || suggestion.email}</span>
  </div>
);

const Users = () => {
  const [userList, setUserList] = useState([]);
  const [userListAll, setUserListAll] = useState([]);
  const [suggestions, setSuggestions] = useState([]);
  const [value, setValue] = useState("");
  const [toShow, setToShow] = useState(25);
  const [pCounter, setPCounter] = useState([]);
  const [pFrom, setPFrom] = useState(0);
  const [pTo, setPTo] = useState(25);
  const [cFrom, setCFrom] = useState(0);
  const [cTo, setCTo] = useState(5);
  const [userInfo, setUserInfo] = useState(null);
  const [back, setBack] = useState(false);
  const [sortConfig, setSortConfig] = useState({
    key: "name",
    direction: "asc",
  });
  const stationId = useSelector((state) => state.user.stationId);
  const fixedTopRef = useRef(null);

  const dispatch = useDispatch();

  useEffect(() => {
    dispatch(clearSearch());
  }, [dispatch]);

  useEffect(() => {
    const bar = fixedTopRef.current;
    const root = bar?.closest(".users");
    if (!bar || !root) return;

    const syncFixedTopHeight = () => {
      root.style.setProperty(
        "--users-fixed-top-height",
        `${bar.offsetHeight}px`,
      );
    };

    syncFixedTopHeight();
    const ro = new ResizeObserver(() =>
      requestAnimationFrame(syncFixedTopHeight),
    );
    ro.observe(bar);
    return () => ro.disconnect();
  }, []);

  const onChange = (event, { newValue }) => {
    setValue(newValue);
  };
  const getSuggestions = ({ value }) => {
    const inputValue = value.trim().toLowerCase();
    if (!inputValue) {
      setSuggestions([]);
      return;
    }
    const data = userList.filter((user) => {
      const phoneMatch =
        user.phone?.includes(inputValue) || user.phone2?.includes(inputValue);
      const emailMatch = user.email?.toLowerCase().includes(inputValue);
      const firstNameMatch = user.firstName?.toLowerCase().includes(inputValue);
      const lastNameMatch = user.lastName?.toLowerCase().includes(inputValue);
      const webIdMatch =
        user.CustomerWebId?.toString().includes(inputValue) ||
        user.id?.toString().includes(inputValue);
      return (
        phoneMatch ||
        emailMatch ||
        firstNameMatch ||
        lastNameMatch ||
        webIdMatch
      );
    });

    setSuggestions(data);
  };
  const onSuggestionsClearRequested = () => {
    setSuggestions([]);
    setValue("");
  };
  const onSuggestionSelected = (suggestion, method) => {
    if (method.method === "click" || method.method === "enter") {
      const userList1 = userList.filter(
        (elem) => elem.id === method.suggestion.id,
      );
      setUserList(userList1);
      setBack(true);
    }
  };
  const updateUserList = () => {
    if (back) {
      setBack(false);
    }
    resetCounter();
    setUserList(userListAll);
    setPCounter(
      Array.from(Array(Math.ceil(userListAll.length / toShow)).keys()),
    );
  };

  const getUsers = useCallback(() => {
    getAllCustomer(stationId)
      .then((x) => {
        setUserList(x.data);
        setUserListAll(x.data);
        setPCounter(
          Array.from(Array(Math.ceil(x.data.length / toShow)).keys()),
        );
      })
      .catch(() => console.log("error"));
  }, [stationId, toShow]);

  useEffect(() => {
    getUsers();
  }, [getUsers]);

  const showPaggination = (number) => {
    let val = number * toShow;
    setCFrom(number);
    setCTo(number + 5);
    setPFrom(val);
    setPTo(val + toShow);
    window.scrollTo(0, 0);
  };

  const UpPaggination = () => {
    setCFrom(cFrom + 1);
    setCTo(cTo + 1);
    setPFrom(pFrom + toShow);
    setPTo(pTo + toShow);
    window.scrollTo(0, 0);
  };

  const downPaggination = () => {
    setCFrom(cFrom - 1);
    setCTo(cTo - 1);
    setPFrom(pFrom - toShow);
    setPTo(pTo - toShow);
    window.scrollTo(0, 0);
  };

  const toShowFun = (num) => {
    let pCounter = Array.from(Array(Math.ceil(userList.length / num)).keys());
    setToShow(num);
    setPCounter(pCounter);
    setPFrom(0);
    setPTo(num);
    setCFrom(0);
    setCTo(5);
    window.scrollTo(0, 0);
  };
  const resetCounter = () => {
    setToShow(25);
    setPFrom(0);
    setPTo(25);
    setCFrom(0);
    setCTo(5);
  };

  const getSortValue = (user, key) => {
    switch (key) {
      case "name":
        return `${user.lastName || ""} ${user.firstName || ""}`.trim();
      case "id":
        return user.id ?? user.CustomerWebId ?? "";
      case "email":
        return user.email || "";
      case "phone":
        return user.phone || user.phone2 || "";
      default:
        return "";
    }
  };

  const sortedUserList = useMemo(() => {
    const users = [...userList];
    users.sort((a, b) => {
      const aValue = getSortValue(a, sortConfig.key);
      const bValue = getSortValue(b, sortConfig.key);
      const aIsNumber = typeof aValue === "number";
      const bIsNumber = typeof bValue === "number";

      let comparison = 0;
      if (aIsNumber && bIsNumber) {
        comparison = aValue - bValue;
      } else {
        comparison = String(aValue).localeCompare(String(bValue), "he", {
          numeric: true,
          sensitivity: "base",
        });
      }

      return sortConfig.direction === "asc" ? comparison : -comparison;
    });
    return users;
  }, [userList, sortConfig]);

  const toggleSort = (key) => {
    setSortConfig((prev) => {
      if (prev.key === key) {
        return { key, direction: prev.direction === "asc" ? "desc" : "asc" };
      }
      return { key, direction: "asc" };
    });
    resetCounter();
  };

  const renderSortIndicator = (key) => {
    if (sortConfig.key !== key) return "";
    return sortConfig.direction === "asc" ? "▲" : "▼";
  };

  return (
    <div className="users">
      <div className="users-fixed-top" ref={fixedTopRef}>
        <div className="users-title-bar">
          <h1 className="title-role">לקוחות</h1>
          {!back ? (
            <span className="users-count">
              {"נמצאו " + userList.length + " לקוחות"}
            </span>
          ) : null}
        </div>
        <div className="users-header">
          {back ? (
            <span className="arrow-side">
              <button
                type="button"
                onClick={updateUserList}
                className="users-icon-btn"
                aria-label="חזרה"
                title="חזרה"
              >
                <ArrowLeft aria-hidden size={22} strokeWidth={2} />
              </button>
            </span>
          ) : null}
          {!back ? (
            <div className="search">
              <Autosuggest
                suggestions={suggestions}
                onSuggestionsFetchRequested={getSuggestions}
                onSuggestionSelected={onSuggestionSelected}
                onSuggestionsClearRequested={onSuggestionsClearRequested}
                getSuggestionValue={getSuggestionValue}
                renderSuggestion={renderSuggestion}
                inputProps={{
                  placeholder: "חפש לקוח",
                  value,
                  onChange: onChange,
                }}
                highlightFirstSuggestion={true}
              />
              <span className="placeholder users-icon-static" aria-hidden>
                <SearchIcon size={20} strokeWidth={2} />
              </span>
            </div>
          ) : null}
        </div>
        <ListPagination
          className="users-pagination"
          showPagination={userList.length > toShow}
          toShow={toShow}
          toShowFun={toShowFun}
          cFrom={cFrom}
          cTo={cTo}
          pCounter={pCounter}
          showPaggination={showPaggination}
          downPaggination={downPaggination}
          UpPaggination={UpPaggination}
        />
      </div>
      <div className="users-table-scroll">
        <table className="users-table">
          <thead>
            <tr>
              <th>
                <button
                  type="button"
                  className={`sort-header-btn${
                    sortConfig.key === "name" ? " sort-header-btn--active" : ""
                  }`}
                  onClick={() => toggleSort("name")}
                >
                  <span>שם</span>
                  <span className="sort-indicator">
                    {renderSortIndicator("name")}
                  </span>
                </button>
              </th>
              <th>
                <button
                  type="button"
                  className={`sort-header-btn${
                    sortConfig.key === "id" ? " sort-header-btn--active" : ""
                  }`}
                  onClick={() => toggleSort("id")}
                >
                  <span>מס׳ לקוח</span>
                  <span className="sort-indicator">
                    {renderSortIndicator("id")}
                  </span>
                </button>
              </th>
              <th>
                <button
                  type="button"
                  className={`sort-header-btn${
                    sortConfig.key === "email" ? " sort-header-btn--active" : ""
                  }`}
                  onClick={() => toggleSort("email")}
                >
                  <span>מייל</span>
                  <span className="sort-indicator">
                    {renderSortIndicator("email")}
                  </span>
                </button>
              </th>
              <th>
                <button
                  type="button"
                  className={`sort-header-btn${
                    sortConfig.key === "phone" ? " sort-header-btn--active" : ""
                  }`}
                  onClick={() => toggleSort("phone")}
                >
                  <span>טלפון</span>
                  <span className="sort-indicator">
                    {renderSortIndicator("phone")}
                  </span>
                </button>
              </th>
              <th>פרטים</th>
            </tr>
          </thead>
          <tbody>
            {sortedUserList.length
              ? sortedUserList.map((element, index) =>
                  index >= pFrom && index < pTo ? (
                    <tr key={element.id}>
                      <td key={element.id}>
                        <p>
                          {element.lastName} {element.firstName}
                        </p>
                      </td>
                      <td>
                        <p>{element.id ?? element.CustomerWebId}</p>
                      </td>
                      <td>
                        {" "}
                        <p>{element.email}</p>
                      </td>
                      <td>
                        {" "}
                        <p>{element.phone}</p>
                      </td>
                      <td>
                        <button
                          type="button"
                          className="users-icon-btn"
                          onClick={() => setUserInfo(element.id)}
                          aria-label="פרטים"
                          title="פרטים"
                        >
                          <Info aria-hidden size={22} strokeWidth={2} />
                        </button>
                        {userInfo === element.id ? (
                          <PopUp width="500px" close={() => setUserInfo(null)}>
                            <div className="user-info">
                              {formatUserAddress(element) ? (
                                <div>
                                  <span>כתובת:</span>
                                  <span>{formatUserAddress(element)}</span>
                                </div>
                              ) : (
                                <div>
                                  <span>כתובת לא זמינה</span>
                                </div>
                              )}
                            </div>
                          </PopUp>
                        ) : null}
                      </td>
                    </tr>
                  ) : null,
                )
              : null}
          </tbody>
        </table>
      </div>
    </div>
  );
};

export default Users;
